import React, { createContext, Component } from 'react';
import Polyglot from 'node-polyglot';
import { object, string, element, bool } from 'prop-types';
import { get } from '../http';
import { UHF } from '../constants';
import config from '../config';
import defaultPhrases from './locales';

export const LocaleProviderCtx = createContext();

let currentLocale = UHF.DEFAULT_LANGUAGE;
let polyglot = new Polyglot({
  locale: UHF.DEFAULT_LANGUAGE,
  phrases: defaultPhrases.en,
});
const englishLocale = 'en-US';
export const setCurrentLocale = locale => {
  currentLocale = locale;
};

export const setPolyglot = newPolyglot => {
  polyglot = newPolyglot;
};

export const translate = (key, option = {}) => {
  return polyglot ? polyglot.t(key, option) : key;
};

export const getCurrentLocale = () => currentLocale;

class LocaleProvider extends Component {
  state = {
    polyglot,
  };

  componentDidMount() {
    this.updatePolyglot();
  }

  componentDidUpdate(prevProps) {
    const isFilterInitChanged = prevProps.isInit !== this.props.isInit;
    const isLocaleChanged = prevProps.locale !== this.props.locale;
    const isLocalePhrasesChanged =
      prevProps.localePhrases !== this.props.localePhrases;

    if (
      this.props.isInit &&
      (isFilterInitChanged || isLocaleChanged || isLocalePhrasesChanged)
    ) {
      this.updatePolyglot();
    }
  }

  updatePolyglot = () => {
    const { locale = UHF.DEFAULT_LANGUAGE, isInit } = this.props;
    var propLocale = locale;
    if (locale.toUpperCase() === englishLocale.toUpperCase()) {
      propLocale = 'en-gb';
    }
    if (!isInit) return;
    if (this.props.localePhrases) {
      setCurrentLocale(locale);
      polyglot = new Polyglot({
        locale: locale,
        phrases: this.props.localePhrases,
      });
      this.setState({
        polyglot,
      });
    } else {
      // TODO: split snap and hotel locale file, this endpoint can be passed as prop
      const IGNORE_CACHE = 'ignoreCache=1';
      get(
        `/snap/lob/translations/${propLocale}/file.json?${IGNORE_CACHE}?${new Date()}`,
        {
          baseUrl: config.REACT_APP_NEW_METADATA_BASE_URL,
        }
      )
        .then(result => {
          if (result.status === 200) {
            setCurrentLocale(locale);
            polyglot = new Polyglot({
              locale: locale,
              phrases: result.body,
            });
            this.setState({
              polyglot,
            });
          } else {
            this.setDefaultPolyglot();
          }
        })
        .catch(() => {
          this.setDefaultPolyglot();
        });
    }
  };

  setDefaultPolyglot = () => {
    setCurrentLocale(UHF.DEFAULT_LANGUAGE);
    polyglot = new Polyglot({
      locale: UHF.DEFAULT_LANGUAGE,
      phrases: defaultPhrases.en,
    });
    this.setState({
      polyglot,
    });
  };

  render() {
    const { children } = this.props;

    return (
      <LocaleProviderCtx.Provider value={polyglot}>
        {children}
      </LocaleProviderCtx.Provider>
    );
  }
}

LocaleProvider.propTypes = {
  children: object,
  locale: string,
  isInit: bool,
  loadingComponent: element,
  localePhrases: object,
};

LocaleProvider.defaultProps = {
  locale: 'en-gb',
  localePhrases: null,
};

export default LocaleProvider;
